import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Col, Container, Form, Label, Row } from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "../Utils/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { validationSchemaForUser } from "../UserManagement/Constant/valiadationshema";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import { createUser } from "../../slices/UserManagement/CreateUser/thunk";
import { updateUser } from "../../slices/UserManagement/UpdateUser/thunk";
import { getUserByName } from "../../slices/UserManagement/GetUserByName/thunk";
import { LabelText } from "../Utils/Input";
import ProviderDetail from "./ProviderDetail";
import { validationSchemaForProfile ,validationSchemaForChangePassword,validationSchemaForCustomer} from "./validationSchemaForProfile";
import { fetchCustomer } from "../../slices/customer/fetchcustomer/thunk";
import { fetchCountries } from "../../slices/customer/countries/thunk";
import { countryOptionss } from "../OperatorManagement/Constant/Options";
import { fetchStates } from "../../slices/customer/states/thunk";
import { fetchCities } from "../../slices/customer/cities/thunk";
import { handleSubmitFunction } from "../LightWeightCustomer/Constant/formUtil";

export default function CreateProvider({ isChangePasswordModal,setIsEdit, customerPermission, roleName, profilePermission, isEdit, isProfile, currentSelectedFile, setDialCode, customerId, dialCode, setSelectedState, stateData, cityData, setSelectedCountry, profileOptions, fetchCustomerData, user, userId, navigate, dispatch, changePassword, profile,handleImageUpload}) {
    const location = useLocation();
    const [changePasswordStatus, setChangePasswordStatus] = useState(false);
    const [loading, setLoading] = useState()

    const initialValues = {
        firstname: user?.profile?.firstName,
        lastname: user?.profile?.lastName,
        username: user?.userDetails?.userName,
        userrole: { value: user?.role, label: user?.role },
        phone: `${user?.userDetails?.dialCode} ${user?.userDetails?.phone}`,
        email: user?.email,
        status: { value: user?.status, label: user?.status },
        newPassword: "",
        confirmNewPassword: ""
    }
    const initialFormValues= {
        accountNumber: "",
        firstName: "",
        lastName: "",
        email: "",
        mobile:  "",
        addressLine1: "",
        addressLine2: "",
        country: "",
        state: "",
        city: "" ,
        zipCode:"" ,
        dialCode: '',
        subscriptions: [],
        attributeList: []
    }
    if(roleName=="Customer" && fetchCustomerData){
        const { firstName, lastName, userName, email, mobile, addressLine1, addressLine2, zipCode, country, state, city, subscriptionList, attributeList, billingProfile,tags } = fetchCustomerData.customerInfo;
            initialFormValues.firstName = firstName;
            initialFormValues.lastName = lastName;
            initialFormValues.userName = userName;
            initialFormValues.email = email;
            initialFormValues.mobile = mobile;
            initialFormValues.bdom = { "value": billingProfile.bdom, "label": billingProfile.bdom }
            initialFormValues.addressLine1 = addressLine1;
            initialFormValues.addressLine2 = addressLine2;
            initialFormValues.zipCode = zipCode;
            initialFormValues.isSSOUser = fetchCustomerData.customerInfo.isSSOUser || false;
            initialFormValues.country = { "value": country, "label": country };
            initialFormValues.state = { "value": state, "label": state };
            initialFormValues.city = { "value": city, "label": city };
            initialFormValues.categories = tags?.map((item) => ({
                value: item,
                label: item
              })) || [];
            if (customerPermission?.has("autoload")  || roleName === "Customer") {
                initialFormValues.phone = fetchCustomerData?.customerInfo?.dialCode + fetchCustomerData?.customerInfo?.mobile
                initialFormValues.accountNumber = fetchCustomerData?.customerInfo?.customerId
                const imsiAttribute = fetchCustomerData?.customerInfo?.attributeList?.find(attr => attr.name === "imsi");
                initialFormValues.imsi = imsiAttribute ? imsiAttribute.value : "";
            }

            if (subscriptionList) {
                initialFormValues.subscriptions = [];
                subscriptionList.forEach((resp) => {
                    setSubscriptionId((id) => [...id, resp.subscriptionId]);
                    initialFormValues.subscriptions.push({
                        "validFrom": resp.subscribedOffers[0].validFrom,
                        "offerCode": { "value": resp.subscribedOffers[0].offerCode, "label": resp.subscribedOffers[0].offerCode },
                        "validTo": resp.subscribedOffers[0].validTo
                    });
                });
            }

            if (attributeList) {
                initialFormValues.attributeList = [];
                attributeList.forEach((resp) => {
                    initialFormValues.attributeList.push({
                        "value": resp.value,
                        "name": { "value": resp.name, "label": resp.name }
                    });
                });
            }

    }
    return (
        <React.Fragment>
            <div id='csms' >
                <Formik
                    validationSchema={isChangePasswordModal?validationSchemaForChangePassword():roleName=="Customer"?validationSchemaForCustomer():validationSchemaForProfile()}
                    initialValues={roleName !== "Customer" ? initialValues : initialFormValues}
                >
                    {({ handleChange, handleBlur, handleSubmit, errors, touched, values, setFieldValue, setFieldTouched ,dirty}) => (
                        <Form className='needs-validation' onSubmit={handleSubmit}>
                            <Container fluid>
                                {/* <ToastContainer position='top-center' /> */}
                                <Row>
                                    {loading && (<Loader />)}
                                    <Col lg={12}>
                                        <div >
                                            {profilePermission &&
                                                <ProviderDetail isChangePasswordModal={isChangePasswordModal}setDialCode={setDialCode} customerId={customerId} dialCode={dialCode} setIsEdit={setIsEdit} isEdit={isEdit} setSelectedState={setSelectedState} stateData={stateData} cityData={cityData} setSelectedCountry={setSelectedCountry} profileOptions={profileOptions} fetchCustomerData={fetchCustomerData} profilePermission={profilePermission} values={values} errors={errors} touched={touched} setFieldTouched={setFieldTouched} setFieldValue={setFieldValue} handleBlur={handleBlur} handleChange={handleChange} user={user} userId={userId} navigate={navigate} dispatch={dispatch} setLoading={setLoading} changePassword={changePassword} profile={profile} setChangePasswordStatus={setChangePasswordStatus} isProfile={isProfile} handleImageUpload={handleImageUpload} initialValues={initialValues} initialFormValues={initialFormValues} dirty={dirty}/>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}